export const githubApiUrl = 'https://api.github.com/'

export const swarmOwnerName = 'SwarmMarkets'
export const openOtcRepoName = 'open-dotc'
export const pathToAuthorizations = 'authorizations'
